import React from 'react';
import './app-footer.scss'


export const AppFooter = () => {

  return (
    <footer class="footer--primary">
      <div class="column">
        <div class="footer--logo">
          <svg class="logo" viewBox="0 0 1000 232.9">
            <g>
              <g>
                <path class="st0" d="M100.7,3v17.6c0,2.5-1.3,4.8-3.5,6.1L27.6,67.1c-2,1.2-3.2,3.3-3.2,5.6v89.6c0,1.1,0.6,2.1,1.5,2.6l30.8,17.9
                  c0.9,0.5,1.5,1.5,1.5,2.6v19.9c0,2.3-2.5,3.8-4.5,2.6L1.5,177.5C0.6,177,0,176,0,174.9V58c0-1.1,0.6-2.1,1.5-2.6l94.7-55
                  C98.2-0.7,100.7,0.7,100.7,3z"></path>
                <path class="st0" d="M68.4,140.7l30.8,17.9c0.9,0.5,1.5,1.5,1.5,2.6v68.7c0,2.3-2.5,3.8-4.5,2.6l-18.4-10.7
                  c-0.9-0.5-1.5-1.5-1.5-2.6l0-45.4c0-1.1-0.6-2.1-1.5-2.6l-30.8-17.9c-0.9-0.5-1.5-1.5-1.5-2.6V82.1c0-1.1,0.6-2.1,1.5-2.6
                  l52.2-30.3c2-1.2,4.5,0.3,4.5,2.6v19.9c0,1.1-0.6,2.1-1.5,2.6L68.4,92.2c-0.9,0.5-1.5,1.5-1.5,2.6v43.3
                  C66.9,139.2,67.4,140.1,68.4,140.7z"></path>
                <path class="st1" d="M219.4,60v112.9c0,2.3-1.2,4.5-3.3,5.7l-92.9,53.9c-2,1.2-4.5-0.3-4.5-2.6v-17.6c0-2.5,1.3-4.8,3.5-6.1
                  l71.3-41.4c0.9-0.5,1.5-1.5,1.5-2.6V70.7c0-1.1-0.6-2.1-1.5-2.6l-30.8-17.9c-0.9-0.5-1.5-1.5-1.5-2.6V27.7c0-2.3,2.5-3.8,4.5-2.6
                  l50.5,29.3C218.2,55.5,219.4,57.7,219.4,60z"></path>
                <path class="st1" d="M176.9,82.1v66.3c0,2.5-1.3,4.8-3.5,6l-50.3,29.2c-2,1.2-4.5-0.3-4.5-2.6v-19.9c0-1.1,0.6-2.1,1.5-2.6
                  l30.8-17.9c0.9-0.5,1.5-1.5,1.5-2.6V94.8c0-1.1-0.6-2.1-1.5-2.6l-30.8-17.9c-0.9-0.5-1.5-1.5-1.5-2.6V3c0-2.3,2.5-3.8,4.5-2.6
                  l18.4,10.7c0.9,0.5,1.5,1.5,1.5,2.6V59c0,1.1,0.6,2.1,1.5,2.6l30.8,17.9C176.4,80.1,176.9,81.1,176.9,82.1z"></path>
              </g>
              <g>
                <path class="st2" d="M369.7,58.1c23.8,0,38.7,14.4,38.7,38c0,23.6-14.9,37.9-38.7,37.9h-25.5c-1.7,0-3,1.3-3,3v34.5
                  c0,1.7-1.3,3-3,3h-14.7c-1.7,0-3-1.3-3-3V61.1c0-1.7,1.3-3,3-3H369.7z M367.7,114.8c12,0,19-6.9,19-18.7s-7-18.8-19-18.8h-23.6
                  c-1.7,0-3,1.3-3,3v31.5c0,1.7,1.3,3,3,3H367.7z"></path>
                <path class="st2" d="M574.6,89.6c1.7,0,3,1.3,3,3v84.7c0,22.5-11.3,35.7-36.1,35.7c-16.2,0-27.7-5.2-34.1-15.7
                  c-2.3-3.6-2.7-5.8,1.1-7.6l8.2-4.4c3.9-2,4.8-1,7.3,2.4c3.4,5.6,9.2,8.4,17.2,8.4c11.6,0,17.4-5.9,17.4-17.7v-4
                  c0-1.9-1.7-3.3-3.6-2.9c-5.5,1-10.8,1.6-15.9,1.6c-22.9,0-34.3-11.8-34.3-32.9V92.6c0-1.7,1.3-3,3-3h13c1.7,0,3,1.3,3,3v46.7
                  c0,10.8,5.9,16.2,17.9,16.2c4.7,0,9.5-0.6,14.5-1.7c1.4-0.3,2.4-1.5,2.4-2.9V92.6c0-1.7,1.3-3,3-3H574.6z"></path>
                <path class="st2" d="M629.2,87.1c17.5,0,29.3,5.9,35.1,17.5c1.8,3.3,0.8,5.7-2.6,7.4l-7.4,2.9c-3.8,1.5-4.8,1.1-6.9-2.3
                  c-3.1-5.7-9-8.5-17.7-8.5c-10.3,0-15.4,2.9-15.4,8.8c0,7.2,4.9,8.9,19.2,10.2c22.3,2.1,33.4,8,33.4,26.4
                  c0,16.6-12.6,27.4-35.4,27.4c-19.2,0-31.5-6.6-36.6-19.8c-1.3-3.4-0.2-5.7,3.3-6.9l7.4-2.3c3.3-1.3,5.2-0.7,6.7,3.1
                  c2.5,6.1,8.7,9,18.5,9c11.6,0,17.4-3.3,17.4-9.7c0-7.2-5.1-9-19.7-10.5c-7.7-0.8-12.1-1.5-18.5-3.9c-3.1-1.1-5.7-2.6-7.7-4.4
                  c-3.9-3.4-6.9-9.7-6.9-18C595.5,97.3,607.1,87.1,629.2,87.1z"></path>
                <path class="st2" d="M875.7,87.1c22.9,0,34.1,11.8,34.1,32.9v51.4c0,1.7-1.3,3-3,3h-13c-1.7,0-3-1.3-3-3v-50.9
                  c0-10.7-5.9-16.1-17.9-16.1c-5.2,0-10.5,0.7-15.7,2.1c-0.8,0.3-1.1,0.8-1.1,1.6v63.2c0,1.7-1.3,3-3,3h-13c-1.7,0-3-1.3-3-3v-69.4
                  c0-5.2,1.1-7.2,6.4-9.3C852.8,88.9,863.4,87.1,875.7,87.1z"></path>
                <path class="st2" d="M927.2,121.4c0-22.3,11.5-34.3,34.3-34.3c4.3,0,9.6,0.5,16,1.5c1.8,0.3,3.5-1.1,3.5-3l0-29.5c0-1.7,1.3-3,3-3
                  h13c1.7,0,3,1.3,3,3v106.5c0,5.2-1.3,6.9-6.6,9c-9.3,3.4-19.5,5.2-30.6,5.2c-23.8,0-35.6-11-35.6-33.1V121.4z M981,109.1
                  c0-1.4-1-2.7-2.4-2.9c-5.4-1.1-9.9-1.6-13.5-1.6c-12.6,0-18.8,5.7-18.8,17.4v21.3c0,11,6.1,16.4,18.4,16.4
                  c5.7,0,10.8-0.7,15.1-1.8c0.8-0.3,1.3-1,1.3-1.8L981,109.1z"></path>
                <path class="st2" d="M712.6,107.2h17.8c1.7,0,3-1.3,3-3V92.6c0-1.7-1.3-3-3-3h-17.8c-1.7,0-3-1.3-3-3V72.9c0-1.7-1.3-3-3-3h-13
                  c-1.7,0-3,1.3-3,3v13.7c0,1.7-1.3,3-3,3h-10.2c-1.7,0-3,1.3-3,3v11.6c0,1.7,1.3,3,3,3h10.2c1.7,0,3,1.3,3,3l0,45.6
                  c0,30.2,39.4,18.3,39.4,18.3c2.7-0.9,3.5-1.9,3.4-3.4l-2.5-9.9c-1.6-5.4-1.9-6.3-4.6-5.6c-2,0.7-3.9,1.6-8.4,2.1
                  c-4.1,0.6-8.3-2.8-8.3-8.3v-38.8C709.6,108.5,710.9,107.2,712.6,107.2z"></path>
                <path class="st2" d="M451.4,87.1c23.4,0,35.1,11.3,35.1,33.8v42.5c0,5.7-1.3,7.4-5.9,9.3c-6.6,2.8-16.4,4.3-29.5,4.3
                  c-13.9,0-23.4-2.1-28.7-6.6c-5.2-4.3-7.9-11-7.9-20c0-19.5,10.5-26.4,37.2-26.4c1,0,5.2,0.3,12.6,0.7c1.7,0.1,3.2-1.3,3.2-3v-1.4
                  c0-10.7-4.6-16.2-16.4-16.2c-8,0-13.8,2.6-17.2,7.9c-2.4,3.4-3.3,3.8-6.9,2.5c-0.1,0-0.2-0.1-0.2-0.1l-7.4-3.2
                  c-3.6-1.6-3.6-3.6-1.8-6.9C423.4,92.9,434.7,87.1,451.4,87.1z M467.5,143.3c0-1.6-1.3-2.9-2.9-3c-9.6-0.4-14.5-0.7-15-0.7
                  c-11.8,0-15.7,3.4-15.7,10.7c0,7.4,3.4,11,15.4,11c7,0,12.5-0.5,16.4-1.3c1.1-0.5,1.8-1.1,1.8-2.3V143.3z"></path>
                <path class="st2" d="M783,87.1c23.4,0,35.1,11.3,35.1,33.8v42.5c0,5.7-1.3,7.4-5.9,9.3c-6.6,2.8-16.4,4.3-29.5,4.3
                  c-13.9,0-23.4-2.1-28.7-6.6c-5.2-4.3-7.9-11-7.9-20c0-19.5,10.5-26.4,37.2-26.4c1,0,5.2,0.3,12.6,0.7c1.7,0.1,3.2-1.3,3.2-3l0-1.4
                  c0-10.7-4.6-16.2-16.4-16.2c-8,0-13.8,2.6-17.2,7.9c-2.4,3.4-3.3,3.8-6.9,2.5c-0.1,0-0.2-0.1-0.2-0.1l-7.4-3.2
                  c-3.6-1.6-3.6-3.6-1.8-6.9C755,92.9,766.3,87.1,783,87.1z M799.1,143.3c0-1.6-1.3-2.9-2.9-3c-9.6-0.4-14.5-0.7-15-0.7
                  c-11.8,0-15.7,3.4-15.7,10.7c0,7.4,3.4,11,15.4,11c7,0,12.5-0.5,16.4-1.3c1.1-0.5,1.8-1.1,1.8-2.3L799.1,143.3z"></path>
              </g>
            </g>
          </svg>
        </div>

        <div class="footer--description">
          <p>Paystand is on a mission to create a more open financial system, starting with B2B payments. Using blockchain and cloud technology, we pioneered Payments-as-a-Service to digitize and automate your entire cash lifecycle. Our software makes it possible to digitize receivables, automate processing, reduce time-to-cash, eliminate transaction fees, and enable new revenue.</p>
        </div>

      </div>

      <div class="column">
        <div class="column">
          <h5>Solutions</h5>
          <ul>
            <li class="hs-menu-item"><a href="https://www.paystand.com/solutions/payments">Payments</a></li>
            <li class="hs-menu-item"><a href="https://www.paystand.com/integrations">Integrations</a></li>
            <li class="hs-menu-item"><a href="https://www.paystand.com/solutions/software-platforms">Software Platforms</a></li>
            <li class="hs-menu-item"><a href="https://www.paystand.com/solutions/paystand-api">APIs</a></li>
            <li class="hs-menu-item"><a href="https://www.paystand.com/solutions/enterprise-blockchain">Enterprise Blockchain</a></li>
          </ul>

          <h5>By Department</h5>
          <ul>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://www.paystand.com/solutions/accounts-receivable" role="menuitem">Accounts Receivable</a></li>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://www.paystand.com/technology/zero-card" role="menuitem">Accounts Payable</a></li>
          </ul>
        </div>

        <div class="column">
          <h5>Resources</h5>

          <ul>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://www.paystand.com/blog">Blog</a></li>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://www.paystand.com/resources/case-studies">Case Studies</a></li>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://www.paystand.com/resources/datasheets">Datasheets</a></li>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://www.paystand.com/resources/whitepapers">eBooks</a></li>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://www.paystand.com/resources/webinars">Webinars</a></li>
          </ul>

          <h5>Legal</h5>

          <ul>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://www.paystand.com/privacy" role="menuitem">Privacy Policy</a></li>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://www.paystand.com/terms-of-service" role="menuitem">Terms of Service</a></li>
          </ul>
        </div>

        <div class="column">
          <h5>Integrations</h5>

          <ul>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://www.paystand.com/integrations/netsuite">NetSuite</a></li>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://www.paystand.com/integrations/xero">Xero</a></li>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://www.paystand.com/integrations/magento">Magento</a></li>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://www.paystand.com/integrations/woocommerce">WooCommerce</a></li>
          </ul>

          <h5>Technology</h5>

          <ul>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://www.paystand.com/technology/paystand-bank-network">Paystand Bank Network</a></li>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://www.paystand.com/technology/zero-card">Zero Card</a></li>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://www.paystand.com/accept-echecks">eCheck and ACH</a></li>
          </ul>
        </div>

        <div class="column">
          <h5>Company</h5>

          <ul>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://www.paystand.com/about">About</a></li>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://www.paystand.com/careers">Careers</a></li>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://www.paystand.com/press">Press</a></li>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://www.paystand.com/pricing">Pricing</a></li>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://www.paystand.com/contact">Contact</a></li>
          </ul>

          <h5>Support</h5>
          <ul>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://support.paystand.com">Knowledge Base</a></li>
            <li class="hs-menu-item hs-menu-depth-1"><a href="https://developers.paystand.com">Developer Hub</a></li>
          </ul>
        </div>
      </div>

      <div class="meta--content">
        <div class="column">
          <div class="social-media--container">

            <a href="https://www.facebook.com/Paystand/" class="social-media--button" target="_blank">
              <span>
              <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264 512" aria-hidden="true">
                <g id="layer1">
                  <path d="M76.7 512V283H0v-91h76.7v-71.7C76.7 42.4 124.3 0 193.8 0c33.3 0 61.9 2.5 70.2 3.6V85h-48.2c-37.8 0-45.1 18-45.1 44.3V192H256l-11.7 91h-73.6v229">
                  </path>
                </g>
              </svg>
              </span>
            </a>


            <a href="https://twitter.com/paystand" class="social-media--button" target="_blank">
              <span>
              <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-hidden="true">
                <g id="layer1">
                  <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z">
                  </path>
                </g>
              </svg>
              </span>
            </a>


            <a href="https://www.linkedin.com/company/paystand/" class="social-media--button" target="_blank">
              <span>
              <svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" aria-hidden="true">
                <g id="layer1">
                  <path d="M100.3 480H7.4V180.9h92.9V480zM53.8 140.1C24.1 140.1 0 115.5 0 85.8 0 56.1 24.1 32 53.8 32c29.7 0 53.8 24.1 53.8 53.8 0 29.7-24.1 54.3-53.8 54.3zM448 480h-92.7V334.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V480h-92.8V180.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V480z"></path>
                </g>
              </svg>
              </span>
            </a>
          </div>
        </div>

        <div class="column">
          <p>© Paystand, Inc. 2020. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  )
}
